// extracted by mini-css-extract-plugin
export default {"dashboardTitle":"styles_dashboardTitle__90e5b"};